import ParametersList from './ParametersList.vue'
import parametersService from '../../services/parameters/ParametersService.js'
import ApiService from '../../services/ApiService'
import i18n from "../../i18n/index";

export default {
  data() {
    return {
      loadingSaveButton: false,
      hideList: false,
      rules: { required: value => !!value || i18n.t('field-required')},
      dataItems: [],
      parameters: {
        name: '',
        value: '',
        id: null,
        fieldType: null,
        apiUrl: null
      }
    }
  },
  components: {
    ParametersList
  },
  methods: {
    close() {
      this.resetForm()
    },
    async save() {
      if (!this.$refs.branchForm.validate()) {
        this.$notify({
          group: "app",
          type: "error",
          text: i18n.t("app.error-required-fields")
        });
        return;
      }
      await parametersService.createParameters(this.parameters)
        .then(resp => {
          if (resp.data.data == 'ELEMENT_EXITS') {
            this.$notify({
              group: "app",
              type: "warning",
              text: i18n.t('record-already-exists')
            });
            return
          }
          this.$refs.parametersList.getParameters();
          this.$notify({
            group: "app",
            type: "success",
            text: i18n.t('record-successfully-created')
          });
          this.resetForm()
        })
    },
    update(item) {
      this.parameters = item
      this.hideList = true
      if (this.parameters.fieldType === 'select') {
        ApiService.get(this.parameters.apiUrl).then(res => {
          this.dataItems = res.data;
        }).catch(error => {
        });
      }
    },
    resetForm() {
      this.parameters = {};
      this.hideList = false;
      this.dataItems = [];
    }
  }
}
